import { render, staticRenderFns } from "./BadgeCreator.vue?vue&type=template&id=46cacc7c&scoped=true"
import script from "./BadgeCreator.vue?vue&type=script&lang=js"
export * from "./BadgeCreator.vue?vue&type=script&lang=js"
import style0 from "./BadgeCreator.vue?vue&type=style&index=0&id=46cacc7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cacc7c",
  null
  
)

export default component.exports